import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { FiLoader } from "react-icons/fi";
import { BsSearch } from "react-icons/bs";
import { handleCreateRequest } from "../../../../api/requests";
import { AuthContext } from "../../../../contexts/AuthContext";
import formatMoney from "../../../../utils/formatMoney";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import formatAccount from "../../../../utils/formatAccount";
import containsDigit from "../../../../utils/containsDigit";
import formatShort from "../../../../utils/formatShort";
const REACT_APP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export default function CreateRequest({ isVisible, setVisible }: any) {
  const { auth } = useContext(AuthContext);
  const [found, setFound] = useState(false);
  const [keyword, setKeyword] = useState<any>(null);
  const [err, setErr] = useState<any>(null);
  const [customer, setCustomer] = useState<any>(null);
  const [isSearching, setSearching] = useState<any>(false);
  const [customers, setCustomers] = useState<any>(null);
  const [errMessage, setErrMessage] = useState<any>("");
  const [formated, setFormated] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleCreateRequest,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      setVisible(false);
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const onSubmit = async () => {
    const { requestedLimit } = await form.getFieldsValue();
    if (!customer) {
      message.error("Please search customer");
      return;
    }
    const data = {
      businessUnitRef: auth?.businessUnitRef,
      createdBy: auth?._id,
      requestedLimit,
      customerName: customer?.name,
      customerEmail: customer?.email,
      customerMobile: customer?.mobile,
      customerAccount: customer?.account,
      customerPeriod: customer?.periodUsed,
      currentLimit: customer?.currCredit,
      business: customer?.business.name,
      ytdTurnover: customer?.ytdTurnover,
      preTurnover: customer?.preTurnover,
      customerBalance: customer?.balance,
    };

    await mutate(data);
  };

  const handleSearchCustomer = async () => {
    try {
      if (formated) return;
      setSearching(true);

      if (!keyword) {
        setSearching(false);
        return;
      }

      const isAccount = containsDigit(keyword as string);
      if (isAccount) {
        setKeyword(formatAccount(keyword));
        setFormated(true);
      } else {
        setFormated(false);
      }

      const token = sessionStorage.getItem("token");

      const response = await fetch(
        `${REACT_APP_BASE_API_URL}/v1/customers/search?keyword=${keyword}&companyNo=${
          auth?.companyNo === undefined ? "" : auth?.companyNo
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      if (result?.length > 0) {
        setFound(true);
        setCustomers(result);
      } else {
        setFound(false);
        setErrMessage("Customer not found, Please Fill in below");
      }
      setSearching(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClearSearch = () => {
    form.resetFields();
    setKeyword("");
    setFound(false);
    setCustomers([]);
    setErrMessage("");
    setSearching(false);
    setCustomer(null);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      handleSearchCustomer();
    }, 1000);
    return () => clearTimeout(delay);
  }, [keyword]);

  return (
    <Modal
      open={isVisible}
      title="New Credit Limit Request"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={handleClearSearch}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Submit
        </Button>,
      ]}
    >
      <div className="flex flex-col border-b pb-2 mb-2">
        <div className="flex">
          <div className="flex-1">
            <input
              type="text"
              placeholder="Search Customer Name or Account Number"
              className={`border py-1 px-2 rounded-sm flex-1 ${
                err ? "border-red-500" : ""
              }`}
              value={keyword}
              style={{ width: "100%" }}
              onChange={(e) => {
                setErr(false);
                setKeyword(e.target.value);
                setFormated(false);
              }}
            />
          </div>
          <button
            onClick={() =>
              found ? handleClearSearch() : handleSearchCustomer()
            }
            className={`  text-white font-bold py-1 p-2 ml-2 ${
              found
                ? "bg-red-500 hover:bg-red-700"
                : "bg-blue-500 hover:bg-blue-700"
            }`}
          >
            {isSearching ? (
              <FiLoader color="#FFFFFF" />
            ) : (
              <div className="">
                {found ? (
                  <AiOutlineClose color="#FFFFFF" />
                ) : (
                  <BsSearch color="#FFFFFF" />
                )}
              </div>
            )}
          </button>
        </div>

        <div className="mt-1">
          {customers?.length > 0 ? (
            <div>
              {customers?.map((item: any, index: number) => (
                <button
                  className={`flex items-center bg-gray-100 p-2 mb-2 border w-full ${
                    item?._id === customer?._id ? "bg-green-50" : ""
                  }`}
                  onClick={() => setCustomer(item)}
                  key={index}
                >
                  <div
                    className={`flex justify-center items-center w-6 h-6 -mt-2 mr-2 border border-gray-400 ${
                      item?._id === customer?._id && "bg-green-500 text-white"
                    }`}
                  >
                    {item?._id === customer?._id && (
                      <div className="">
                        <AiOutlineCheck />
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col flex-1">
                    <div className="flex font-bold">
                      <div className="w-14 text-left">
                        {formatAccount(item?.account)} :
                      </div>
                      {item?.name}
                    </div>
                    <div className="text-gray-500 text-xxs flex justify-between">
                      <div className="">
                        {item?.business?.name || (
                          <span className="text-red-500">Not Assigned</span>
                        )}{" "}
                      </div>
                      <div className="">
                        Current Credit: {formatShort(item?.currCredit)}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          ) : (
            errMessage && (
              <div className="text-red-500 text-xxs mb-2">{errMessage}</div>
            )
          )}
        </div>
      </div>

      {customer && (
        <div className="my-4">
          <div className="font-bold">Customer Name: {customer?.name}</div>
          <div className="grid grid-cols-12 gap-2">
            <div className="col-span-12 sm:col-span-6">
              <div className="">
                Account No : {formatAccount(customer?.account)}
              </div>
              <div className="">Mobile Number : {customer?.mobile}</div>
              <div className="">Email Address : {customer?.email}</div>
              <div className="">Period Unused : {customer?.periodUsed}</div>
            </div>
            <div className="col-span-12 sm:col-span-6">
              <div className="">
                YTD Turnover : {formatMoney(customer?.ytdTurnover)}
              </div>
              <div className="">
                Prev Turnover : {formatMoney(customer?.preTurnover)}
              </div>
              <div className="">Period Unused : {customer?.periodUsed}</div>
              <div className="">
                Outstanding Balance : {formatMoney(customer?.balance)}
              </div>
            </div>
          </div>
          <div className="">
            Current Credit Limit : {formatMoney(customer?.currCredit) || "-"}
          </div>
        </div>
      )}
      <Form
        id="createUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="requestedLimit"
              label="New Credit Limit Value (TZS)"
              rules={[
                {
                  required: true,
                  message: "Please enter credit limit value",
                },
              ]}
            >
              <Input type="number" step={1000000} placeholder="Amount" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
